import React, { useEffect, useState } from "react";
import Label from "../ui/Label";
import dayjs from "dayjs";
import { pubCall } from "../utils/PubSub";
import { ROUTES } from "../utils/Routes";

export default function ConsoleClockPing(){

    const [currentTime, setCurrentTime] = useState(dayjs());

    useEffect(() => {

       if(window.bm_state.value === ROUTES.GLOBAL.MAINTENANCE){
                  return; 
        }

      const intervalId = setInterval(() => {
        pubCall("extra.ping", {time: dayjs().unix()}, () => {});
        setCurrentTime(dayjs());
      }, 30000); // Update every second

     
  
      return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);
  
    return (
      <Label>
        {currentTime.format('ddd MMM D YYYY h:mm A')}
      </Label>
    );
}